import { render, staticRenderFns } from "./TableItemDraft.vue?vue&type=template&id=3682753b&scoped=true&"
import script from "./TableItemDraft.vue?vue&type=script&lang=ts&"
export * from "./TableItemDraft.vue?vue&type=script&lang=ts&"
import style0 from "./TableItemDraft.vue?vue&type=style&index=0&id=3682753b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3682753b",
  null
  
)

export default component.exports